module.exports = __webpack_public_path__ + "img/logo.996ce718.png";